"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var get = require('lodash/get');

var isUndefined = require('lodash/isUndefined');

var isNumber = require('lodash/isNumber');

var _require = require('../util/mathHelpers'),
    getPrice = _require.getPrice;

var _require2 = require('../util'),
    getPriceTable = _require2.getPriceTable;

function tableLookup(_ref) {
  var opts = _ref.opts,
      component = _ref.component,
      product = _ref.product,
      quantity = _ref.quantity,
      tables = _ref.tables,
      priceSettingsForComponent = _ref.priceSettingsForComponent;
  var keys = opts.keys,
      table_reference = opts.table_reference,
      from = opts.from;

  if (isUndefined(table_reference)) {
    throw new Error("".concat(component.type, ":tableLookup:table_reference is undefined"));
  }

  if (isUndefined(keys)) {
    throw new Error("".concat(component.type, ":tableLookup:keys is undefined"));
  }

  var price_table_name = priceSettingsForComponent[table_reference];
  var price_table_version = product["".concat(price_table_name, "_version")];

  if (!price_table_name) {
    debugger;
  }

  var priceTable = getPriceTable(price_table_name, price_table_version, tables); // if the table is just a constant, just return the constant.
  // whether or not it gets applied is up to the condition

  if (typeof priceTable !== 'undefined' && _typeof(priceTable) !== 'object') {
    return priceTable;
  } // if there's only one key, we can just get the price.
  // if there are multiple keys, we can follow them until the final one.
  // I guess this assumes quantity keys are the final keys.


  var object = from === 'product' ? product : component;
  var numKeys = keys.length;
  var lastKey = keys[numKeys - 1];
  var lastValue = lastKey === 'quantity' ? quantity : object[lastKey];

  if (typeof lastValue === 'undefined') {
    throw new Error("could not get ".concat(lastKey, " from object"));
  }

  var precedingKeys = keys.slice(0, numKeys - 1);
  var finalTable = priceTable;
  var precedingValues = [];

  if (numKeys > 1) {
    precedingValues = precedingKeys.map(function (key) {
      return object[key];
    });
    finalTable = get(priceTable, precedingValues);
  } // getPrice() expects key to be a number, so it can do an
  // interpolation, if necessary.
  // We have to work around this if we want to make it generic.


  var total;

  try {
    if (isNumber(lastValue)) {
      total = getPrice(finalTable, lastValue);
    } else {
      total = finalTable[lastValue];
    }
  } catch (error) {
    precedingValues.push(lastValue);
    throw new Error("could not run tableLookup on ".concat(price_table_name, ", ").concat(keys.join(', '), " (").concat(precedingValues.join(', '), ")"));
  }

  return total;
}

module.exports = tableLookup;